export let SHOW_MEDIA_TYPE_VALUES;
(function (SHOW_MEDIA_TYPE_VALUES) {
  SHOW_MEDIA_TYPE_VALUES[SHOW_MEDIA_TYPE_VALUES["VIDEO_PREVIEW"] = 1] = "VIDEO_PREVIEW";
  SHOW_MEDIA_TYPE_VALUES[SHOW_MEDIA_TYPE_VALUES["COVER_IMAGE"] = 2] = "COVER_IMAGE";
})(SHOW_MEDIA_TYPE_VALUES || (SHOW_MEDIA_TYPE_VALUES = {}));
//# sourceMappingURL=show-media-type-values.js.map